export default __webpack_public_path__ + "static/media/oMaximoPossivel.910e0916.svg";